<template>
  <v-row
  align="center"
  justify="space-between"
  dense>
    <v-col>
      <p class="process-repair-tab-section-title">{{$t(title)}}</p>
      <p v-show="subtitle" :class="`${subtitleBold ? 'font-weight-bold' : ''} process-repair-tab-section-subtitle`">{{$t(subtitle)}}</p>
    </v-col>
    <v-col
    cols="2"
    class="d-flex justify-end align-center">
      <request-id-chip
      :id="requestId"/>
    </v-col>
  </v-row>
</template>

<script>
import RequestIdChip from '@/components/common/process-tabs/shared/RequestIdChip'
export default {
  components: {
    RequestIdChip
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    subtitleBold: {
      type: Boolean,
      default: false
    },
    requestId: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>